// eslint-disable-next-line no-restricted-imports
import { initState } from '../../../../App';

export function resetForm() {
  return initState;
}
